var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2381 2.33827C12.118 2.35637 12.007 2.42128 11.9234 2.52197C11.7156 2.76055 10.1078 4.65717 8.47399 6.58332C6.99448 8.32776 5.7393 9.80955 5.36137 10.2515L2.02229 7.33071C1.91055 7.23087 1.76852 7.18646 1.62796 7.20768C1.48752 7.22875 1.36027 7.3136 1.27465 7.44328C1.18904 7.57297 1.1522 7.73645 1.17241 7.89753C1.19261 8.05847 1.26813 8.20343 1.38207 8.30016L5.09076 11.5441V11.544C5.19313 11.6326 5.31989 11.6758 5.44775 11.6653C5.57562 11.6548 5.69586 11.5915 5.78614 11.487C5.99396 11.2484 7.60182 9.35814 9.2356 7.43213C10.8692 5.50612 12.5283 3.5442 12.6737 3.3773C12.7804 3.25794 12.8384 3.09248 12.8334 2.92149C12.8284 2.75066 12.761 2.59 12.6477 2.47897C12.5344 2.36794 12.3856 2.31691 12.2377 2.33826L12.2381 2.33827Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.6ac5b339332ac72d2010759876837dce.svg";